/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { setDevFeaturesEnabled } from './actions';

export { setDevFeaturesEnabled };
